import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { ApgDeliveryService } from './apg-delivery.service';
import { ErrorHandler } from '../utils/error-handler';
import { DatePipe } from '@angular/common';
import { BoxDetails } from './box-Package';
import { ArrayProject } from '../masterdata/models/arrayProject';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { BoxDeliveryDTO } from '../models/boxDelivery';
import { SearchDelivery } from '../models/searchDelivery';

@Component({
  selector: 'app-apg-delivery',
  templateUrl: './apg-delivery.component.html',
  styleUrls: ['./apg-delivery.component.css']
})
export class ApgDeliveryComponent implements OnInit {
  cols: any[];
  loading: boolean;
  puid: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedLabId: string;
  blocked: boolean;
  isStatus = 'status';
  boxDetails: BoxDetails;
  boxDetailsList: BoxDetails[] = [];
  receivedDate: Date;
  toDate: Date;
  projectsList = [];
  projectData: ArrayProject[] = [];
  selectedProcessFlows: ProcessFlow[];
  sampleTypeList = [];
  selectedProject: ArrayProject;
  fromDate: Date;
  boxDeliveryList: BoxDeliveryDTO[] = [];
  scannedBox: string;
  searchBox: string;
  tableSelectedRow: boolean;
  scannedBoxIds: Set<string>;
  boxlist: SearchDelivery[] = [];
  searchProjectID: any;
  searchsampleID: any;
  totalBoxes: number;

  constructor(private _messagesService: MessagesService, public datepipe: DatePipe,
    private deliveryService: ApgDeliveryService, private masterDataService: MasterDataService) { }

  ngOnInit() {
    this.receivedDate = new Date();
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem('PUID');

    // Table Column headings
    this.cols = [
      { field: 'shipmentId', header: 'Box-ID' },
      { field: 'sender', header: 'Sender' },
      { field: 'shipmentStatus', header: 'Project-ID' },
      { field: 'sentOn', header: 'Status' },
      { field: 'receptionOn', header: 'Reception Date', date: true, format: 'dd.MM.yyyy HH:mm ' },
      { field: 'puid', header: 'PUID' }
    ];
    this.getProjectFromMDM();
  }

  getProjectFromMDM() {
    this.masterDataService.getConfigList(this.selectedLabId, "arrayProject", 0, 100, true).subscribe(
      results => {
        this.projectData = results.data;
        console.log("projectData :", this.projectData)
        this.projectData.forEach(project => {
          this.projectsList.push({ label: project.projectID, value: project })
        })
        this.searchDeliveryList(0, 20);
      },
      error => {
        this.showError(error);
      }
    )
    this.selectedProcessFlows?.forEach(processFlow => {
      this.sampleTypeList.push({ label: processFlow.sampleType, value: processFlow.sampleType })
    });
  }

  populateTable(searchDelivery: SearchDelivery) {
    this.blocked = true;
    this.deliveryService.getBoxDelivery(searchDelivery).subscribe(
      result => {
        this.blocked = false;
        this.boxlist = result.content;
        this.totalBoxes = result.totalElements;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  loadLazy(event) {
    this.loading = true;
    let pageNumber: number = 0;
    if (event.first >= 20) {
      pageNumber = event.first / 20;
    }
    this.searchDeliveryList(pageNumber, event.rows)
    this.loading = false;
  }

  searchDeliveryList(skip: number, limit: number) {
    this.loading = true;
    let searchDelivery = new SearchDelivery();
    searchDelivery.labId = this.selectedLabId;
    searchDelivery.limit = limit;
    searchDelivery.skip = skip;
    searchDelivery.boxId = this.searchBox;
    searchDelivery.projectId = this.searchProjectID ? this.searchProjectID.projectID : '';
    searchDelivery.dateuntill = this.toDate ? new Date(this.toDate.setDate(this.toDate.getDate() + 1)) : this.toDate;
    searchDelivery.fromDate = this.fromDate;
    this.populateTable(searchDelivery)
    this.loading = false;
  }

  clearSelection() {
    this.searchBox = "";
    this.searchProjectID = "";
    this.searchsampleID = "";
    this.toDate = null;
    this.fromDate = null;
    this.searchDeliveryList(0, 20);
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  scanBoxID() {
    let selectedProject = this.selectedProject != undefined ? this.selectedProject.projectID : this.selectedProject;
    if (selectedProject == undefined || selectedProject == null) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Project-ID is empty',
        detail: 'Please give the Project-ID',
      });
      return;
    }
    if (!this.scannedBox || this.scannedBox.trim() == '') {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Box-ID is empty',
        detail: 'Please give the Box-ID',
      });
      return;
    }
    if (this.validateBoxId()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: this.scannedBox + ' is Duplicated',
        detail: 'Please give the valid Box-ID',
      });
      return;
    }
    let boxdetails = new BoxDeliveryDTO();
    boxdetails.boxId = this.scannedBox.trim();
    boxdetails.projectId = this.selectedProject.projectID;
    boxdetails.receptionDate = this.receivedDate;
    boxdetails.sender = this.selectedProject.sender;
    boxdetails.labId = this.selectedLabId;
    boxdetails.puid = this.puid;
    this.validateBoxIdList(boxdetails);
  }

  validateBoxIdList(boxdetails: BoxDeliveryDTO) {
    this.deliveryService.validateBoxId(this.selectedLabId, this.scannedBox.trim(), this.selectedProject.projectID).subscribe(
      result => {
        if (!result.data) {
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: this.scannedBox + ' is Duplicated',
            detail: 'Please give the valid Box-ID',
          });
        } else {
          this.boxDeliveryList.unshift(boxdetails);
          this.scannedBox = '';
        }
      },
    );
  }

  validateBoxId() {
    let flag = false;
    this.boxDeliveryList.forEach(boxdelivery => {
      if (boxdelivery.boxId === this.scannedBox.trim() && boxdelivery.projectId === this.selectedProject.projectID) {
        flag = true;
      }
    });
    return flag;
  }

  completeBoxReception() {
    this.blocked = true;
    this.deliveryService.performBoxReception(this.boxDeliveryList).subscribe(
      _result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Box reception successful',
          detail: 'Reception has been completed for boxes which were present in the table'
        })
        this.boxDeliveryList = [];
        this.scannedBox = null;
        this.searchDeliveryList(0, 20);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  removeRow(event: number) {
    this.boxDeliveryList.splice((event - 1), 1);
  }
}
